/*
 * @Author: 张锐
 * @Date: 2021-04-28 13:59:46
 * @LastEditTime: 2021-04-29 21:21:55
 * @Description: 埋点相关接口
 */

import request from '@comm/utils/request'

/**
 * @description: 埋点
 * @param {String} type 埋点类型
 * @param {String} dictionaryId
 * @param {String} downloadStatus
 * @param {String} downloadType
 * @param {String} downloadFileType
 * @param {Date} diwnloadFileTime
 * @param {String} downloadFIleSize
 * @return {*} Promise
 */
export function buriedPoint (type, dictionaryId, downloadStatus, downloadType, downloadFileType, diwnloadFileTime, downloadFIleSize) {
  let data = {
    dictionaryId
  }
  if (type === 'isUpload') {
    data = {
      dictionaryId,
      browserType: localStorage.browserType,
      brwoserVersion: localStorage.brwoserVersion,
      clickType: downloadStatus,
      storeType: 10
    }
  } else if (type === 'isDown') {
    data = {
      dictionaryId,
      downloadStatus: downloadStatus,
      downloadType: downloadType,
      downloadFileType: downloadFileType,
      downloadFileTime: diwnloadFileTime,
      downloadFileSize: downloadFIleSize,
      storeType: 20
    }
  } else if (type === 'isSorting') {
    data = {
      dictionaryId,
      sortType: downloadStatus,
      storeType: 30
    }
  } else {
    data = {
      dictionaryId,
      storeType: 40
    }
  }
  return request({
    url: '/conversion/buried/four',
    method: 'post',
    data
  })
}

/**
 * @description: 文件转换埋点
 */
export function turnBuriedPoint (type, transferFileName, transferFileSize, transferFileType, transferFileTime, transferStatus, transferType, isSyllabus, transferFilePageSize, isAllPage) {
  let data = {}
  let dictionaryId = 0
  if (type === 'toofd') {
    dictionaryId = 73
  } else if (type === 'ofdtopdf') {
    dictionaryId = 95
  } else if (type === 'topdf') {
    dictionaryId = 110
  } else if (type === 'totxt') {
    dictionaryId = 119
  } else if (type === 'toimg') {
    dictionaryId = 103
  } else {
    dictionaryId = 86
  }
  if (type === 'toimg') {
    data = {
      dictionaryId,
      transferFileName,
      transferFileSize,
      transferFileType,
      transferFileTime,
      transferStatus,
      transferType,
      paperSize: 0,
      paperDirect: 0,
      paperMargin: 0,
      isSyllabus,
      transferFilePageSize,
      isAllPage
    }
  } else {
    data = {
      dictionaryId,
      transferFileName,
      transferFileSize,
      transferFileType,
      transferFileTime,
      transferStatus,
      transferType,
      isSyllabus,
      transferFilePageSize
    }
  }
  return request({
    url: '/conversion/buried/buried_transfer',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/comm/utils/buryingPoint.js